<template>
  <f7-page>
    <navbar>
      <template
        v-slot:nav-title
        class="breadcrumbs"
      >
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/cockpit/', { reloadCurrent: true })"
        >
          {{ $t('Home_navbar_title') }}
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/tabs-result/', { reloadCurrent: true })"
        >
          {{ $t('LeftPanel_title_result') }} ({{ resultProject.name }})
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span class="breadcrumb-title">{{ $t('LeftPanel_subtitle_floor') }}</span>
      </template>
    </navbar>
    <f7-toolbar
      tabbar
      top
      class="tab-class color-title-OpenAir"
    >
      <f7-link
        tab-link
        route-tab-id="WATER-CONTENT-DRAINAGE-LEACHING"
        href="./WATER-CONTENT-DRAINAGE-LEACHING/"
        @click="setTabActive('WATER-CONTENT-DRAINAGE-LEACHING')"
      >
        Contenido de agua y Nitrógeno
      </f7-link>
      <f7-link
        tab-link
        route-tab-id="N-MINERALIZED"
        href="./N-MINERALIZED/"
        @click="setTabActive('N-MINERALIZED')"
      >
        Balance de Nitrógeno
      </f7-link>
    </f7-toolbar>
    <f7-tabs
      routable
      animated
    >
      <f7-tab
        id="WATER-CONTENT-DRAINAGE-LEACHING"
        class="page-content padding-top-half"
      >
        <tab-water-content-drainage-leaching
          v-if="currentTab === 'WATER-CONTENT-DRAINAGE-LEACHING'"
        />
      </f7-tab>
      <f7-tab
        id="N-MINERALIZED"
        class="page-content padding-top-half"
      >
        <tab-n-mineralized v-if="currentTab === 'N-MINERALIZED'" />
      </f7-tab>
    </f7-tabs>
  </f7-page>
</template>
<script>
import { mapState } from 'vuex';
import navbar from '../../../components/navbar/NavBar.vue';
import TabWaterContentDrainageLeaching from '../../../components/result/resultOpenAir/TabWaterContentDrainageLeaching.vue';
import TabNMineralized from '../../../components/result/resultOpenAir/TabNMineralized.vue';

export default {
  name: 'FloorResultPage',
  components: {
    navbar,
    TabWaterContentDrainageLeaching,
    TabNMineralized,
  },
  data() {
    return {
      temperature: [],
      humidity: [],
      solarRadiation: [],
      eto: [],
      loaded: false,
      currentTab: '',
    };
  },
  computed: {
    ...mapState('Result', [
      'resultProject',
    ]),
  },
  beforeMount() {
    this.$f7.preloader.show();
    try {
      this.keyName = this.$f7.views.main.router.currentRoute.path;

      this.loaded = true;
    } catch (e) {
      console.log(e);
    } finally {
      this.$f7.preloader.hide();
    }

    this.$f7.preloader.hide();
  },
  methods: {
    setTabActive(tabSelected) {
      this.currentTab = tabSelected;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../css/mixins";
.block-title-result {
  border-bottom: 1px solid #51A411;
}
.tab-class a.link{
  font-style: normal;
  font-weight: 600;
  text-align: center;
  color: #51A411;
  white-space: normal;
  overflow: hidden;
  font-size: x-small;
  @include md {
    font-size: medium;
  }
}
</style>
